import { formatDateTime, type ChangeRequest } from '@/entities/moderation';

/** Single-line submitted date (`21.09.2026 19:07`, Tashkent wall time). */
export function SubmittedCell({ request }: { request: ChangeRequest }) {
  return (
    <span className="whitespace-nowrap text-table-cell-fg tabular-nums">
      {formatDateTime(request.created_at)}
    </span>
  );
}
